import { render, staticRenderFns } from "./RegistrarDevolucionItems.vue?vue&type=template&id=c24ac62c&scoped=true&"
import script from "./RegistrarDevolucionItems.vue?vue&type=script&lang=js&"
export * from "./RegistrarDevolucionItems.vue?vue&type=script&lang=js&"
import style0 from "./RegistrarDevolucionItems.vue?vue&type=style&index=0&id=c24ac62c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24ac62c",
  null
  
)

export default component.exports